export default __webpack_public_path__ + "static/media/ic_brand.f3e44960.svg";